'use strict';
decimal.$inject = ['$filter', '$browser', '$parse'];
angular.module('schoolLinqApp').directive('decimal', decimal);

function decimal($filter, $browser, $parse) {
	return {
		scope: {
			decimal: '=',
		},
		require: 'ngModel',
		link: function ($scope, $element, $attrs, ngModelCtrl) {
			var scale = 2;

			$scope.$watch('decimal', function (value) {
				//If the decimal scale is loaded via AJAX, watch for when it changes.
				if (typeof value != 'undefined' && value != null) {
					scale = $scope.decimal;
					ngModelCtrl.$render();
				}
			});

			var listener = function () {
				let selectionStart = $element[0].selectionStart;
				let selectionEnd = $element[0].selectionEnd;
				var value = $element.val().replace(/[^0-9\.\-]+/g, '');
				$element.val(value);
				// if the last key pressed was the tab key then don't reposition the cursor
				// because doing so causes problems for IE browsers (ie. they won't move the
				// cursor to the next element on the form).
				if ($element[0].lastKey !== 9) {
					$element[0].selectionStart = selectionStart;
					$element[0].selectionEnd = selectionEnd;
				}
				// make sure the user gets instant feedback that a value is required, if it is.
				let float = parseFloat(value);
				if (!float || float === 0) {
					if ($element.attr('required')) {
						ngModelCtrl.$setValidity('required', false);
						$scope.$apply();
					}
				}
			};

			// This runs when we update the text field
			ngModelCtrl.$parsers.push(function (viewValue) {
				if (!viewValue) return 0;
				let value = viewValue.replace(/[^0-9\.\-]+/g, '');
				let float = parseFloat(value);
				if (!float || float === 0) {
					if ($element.attr('required')) {
						ngModelCtrl.$setValidity('required', false);
					}
				}
				return value;
			});

			// This runs when the model gets updated on the scope directly and keeps our view in sync
			ngModelCtrl.$render = function () {
				if (!ngModelCtrl.$viewValue || parseFloat(ngModelCtrl.$viewValue) === 0) {
					$element.val(parseFloat('0').toFixed(scale));
					if ($element.attr('required')) ngModelCtrl.$setValidity('required', false);
				} else {
					$element.val(parseFloat(ngModelCtrl.$viewValue).toFixed(scale));
				}
			};

			$element.bind('change', listener);
			$element.bind('keydown', function (event) {
				var key = event.keyCode;
				this.lastKey = key;
				// If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
				// This lets us support copy and paste too
				if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
					return;
				}
				$browser.defer(listener); // Have to do this or changes don't get picked up properly
			});

			$element.bind('paste cut', function () {
				$browser.defer(listener);
			});

			$element.on('blur', function (event) {
				var float = parseFloat($element.val());
				if (!float || float === 0) {
					$element.val(parseFloat('0').toFixed(scale));
					if ($element.attr('required')) {
						ngModelCtrl.$setValidity('required', false);
						$scope.$apply();
					}
				} else {
					var model = $parse($element.attr('ng-model'));
					model.assign($scope, float.toFixed(scale));
					$scope.$apply();
					$element.val(float.toFixed(scale));
				}
			});
		},
	};
}
